// extracted by mini-css-extract-plugin
export default {"SurpriseCheckbox":"gift-giver-info-form-styles__SurpriseCheckbox__C6gyG","Tooltip":"gift-giver-info-form-styles__Tooltip__Eg9tv"};